export * from "./init";

export function currencyValidOrDefault(value) {
  let currency = value.replace(/([a-z])/g, (_, c) => c.toUpperCase());

  if (currency.length !== 3 || /[^A-Z]/.test(currency)) {
    currency = "BRL";
  }

  return currency;
}
